/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectUserResponseDto } from '../../models/core-project-user-response-dto';

export interface ProjectUsersControllerDelete$Params {
  tenant: string;
  id: string;
}

export function projectUsersControllerDelete(http: HttpClient, rootUrl: string, params: ProjectUsersControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectUserResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectUsersControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectUserResponseDto>;
    })
  );
}

projectUsersControllerDelete.PATH = '/o2-core/project-users/{tenant}/{id}';
